import { render, staticRenderFns } from "./procedimiento-acciones-correctivas.vue?vue&type=template&id=2711efe9&"
import script from "./procedimiento-acciones-correctivas.vue?vue&type=script&lang=js&"
export * from "./procedimiento-acciones-correctivas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports